import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { UnlinkCaseCommand } from './unlink-case.command';
import { UnlinkCaseResult } from './unlink-case.result';

/**
 * Unlink case use case.
 * Unlinks a case from another case.
 */
@Injectable({ providedIn: 'root' })
export class UnlinkCaseUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(command: UnlinkCaseCommand): Observable<UnlinkCaseResult> {
    this._state.setUnlinkingCase(true);
    this._state.setErrorLinkedCases(null);

    return this._repository.unlinkCase(command.caseId, command.linkedCaseId).pipe(
      tap(() => {
        this._state.removeLinkedCase(command.linkedCaseId);
        this._state.setUnlinkingCase(false);
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._state.setErrorLinkedCases(error.message || 'Failed to unlink case');
        this._state.setUnlinkingCase(false);
        return throwError(() => error);
      })
    );
  }
}
